import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_exclamation_circle_outlined = _resolveComponent("exclamation-circle-outlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_tabs = _resolveComponent("tabs")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_tabs, {
      activeKey: _ctx.activeKey,
      "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeKey) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_tab_pane, {
          key: "1",
          tab: "スタッフ管理"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              onClick: _ctx.add,
              style: {"float":"left"},
              disabled: !_ctx.isAuthority
            }, {
              default: _withCtx(() => [
                _createTextVNode("新規追加")
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]),
            _createVNode(_component_a_table, {
              columns: _ctx.columns,
              "data-source": _ctx.dataSource,
              customRow: _ctx.customRow,
              loading: _ctx.loading
            }, {
              bodyCell: _withCtx(({ column, record }) => [
                (column.name === 'email' && record.id == _ctx.myusercode)
                  ? (_openBlock(), _createElementBlock("b", _hoisted_1, [
                      _createTextVNode(_toDisplayString(record.email) + " ", 1),
                      _createVNode(_component_a_tooltip, null, {
                        title: _withCtx(() => [
                          _createTextVNode("自身のアカウントです")
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_exclamation_circle_outlined, { style: {"margin-top":"3px","margin-left":"15px"} })
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (column.name === 'Name' && record.id == _ctx.myusercode)
                  ? (_openBlock(), _createElementBlock("b", _hoisted_2, _toDisplayString(record.name), 1))
                  : _createCommentVNode("", true),
                (column.dataIndex==='activate')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      (record.activate)
                        ? (_openBlock(), _createBlock(_component_a_tag, {
                            key: 0,
                            color: "green"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("有効")
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_a_tag, {
                            key: 1,
                            color: "red"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("無効")
                            ]),
                            _: 1
                          }))
                    ], 64))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'authority')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      (record.authority)
                        ? (_openBlock(), _createBlock(_component_a_tag, {
                            key: 0,
                            color: "green"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("有効")
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_a_tag, {
                            key: 1,
                            color: "red"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("無効")
                            ]),
                            _: 1
                          }))
                    ], 64))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'calendar')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                      (record.calendar)
                        ? (_openBlock(), _createBlock(_component_a_tag, {
                            key: 0,
                            color: "green"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("表示")
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_a_tag, {
                            key: 1,
                            color: "gray"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("非表示")
                            ]),
                            _: 1
                          }))
                    ], 64))
                  : _createCommentVNode("", true),
                (column.dataIndex==='busho')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                      _createTextVNode(_toDisplayString(_ctx.getBushoLabel(record.busho)), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (column.dataIndex==='affiliation')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                      _createTextVNode(_toDisplayString(_ctx.getAffiliationLabel(record.affiliation)), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (column.dataIndex==='actions')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                      (_ctx.isAuthority || record.id==_ctx.myID)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("a", {
                              onClick: ($event: any) => (_ctx.edit(record))
                            }, "編集 ", 8, _hoisted_3),
                            _createElementVNode("a", {
                              onClick: ($event: any) => (_ctx.editPass(record))
                            }, "パスワード変更", 8, _hoisted_4)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["columns", "data-source", "customRow", "loading"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_tab_pane, {
          key: "2",
          tab: "所属管理"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              onClick: _ctx.createAffiliation,
              style: {"float":"left"},
              disabled: !_ctx.isAuthority
            }, {
              default: _withCtx(() => [
                _createTextVNode("新規作成")
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]),
            _createVNode(_component_a_table, {
              bordered: "",
              dataSource: _ctx.affiliationSource,
              columns: _ctx.affiliationColumns,
              loading: _ctx.loading
            }, {
              bodyCell: _withCtx(({ column, record }) => [
                (column.dataIndex==='operation')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.isAuthority)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            onClick: ($event: any) => (_ctx.editAffiliation(record))
                          }, "編集", 8, _hoisted_5))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["dataSource", "columns", "loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["activeKey"]),
    _createElementVNode("div", null, [
      _createVNode(_component_a_modal, {
        open: _ctx.visible,
        "onUpdate:open": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.visible) = $event)),
        title: _ctx.title,
        onOk: _ctx.handleOk,
        width: "80vw",
        footer: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input_group, {
            compact: "",
            style: {"margin":"2px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(" StaffCode"),
              _createVNode(_component_a_input, {
                placeholder: "StaffCode",
                disabled: !_ctx.createMode,
                value: _ctx.editData.email,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editData.email) = $event))
              }, null, 8, ["disabled", "value"]),
              _createTextVNode(" 名前 "),
              _createVNode(_component_a_input, {
                placeholder: "名前",
                disabled: !_ctx.createMode && _ctx.passEdit,
                value: _ctx.editData.name,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editData.name) = $event))
              }, null, 8, ["disabled", "value"]),
              _hoisted_6,
              _createTextVNode(" 部署"),
              _hoisted_7,
              _createVNode(_component_a_select, {
                placeholder: "部署",
                value: _ctx.editData.busho,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editData.busho) = $event)),
                options: _ctx.bushoSource,
                disabled: !_ctx.createMode && _ctx.passEdit,
                style: {"width":"100%"}
              }, null, 8, ["value", "options", "disabled"]),
              _hoisted_8,
              _createTextVNode(" 所属"),
              _hoisted_9,
              _createVNode(_component_a_select, {
                placeholder: "所属",
                value: _ctx.editData.affiliation,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editData.affiliation) = $event)),
                options: _ctx.affiliationSource,
                disabled: !_ctx.createMode && _ctx.passEdit,
                style: {"width":"100%"}
              }, null, 8, ["value", "options", "disabled"]),
              _createTextVNode(" 役職"),
              _hoisted_10,
              _createVNode(_component_a_input, {
                placeholder: "役職",
                disabled: !_ctx.createMode && _ctx.passEdit,
                value: _ctx.editData.position,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editData.position) = $event))
              }, null, 8, ["disabled", "value"]),
              _hoisted_11,
              _createTextVNode(" 表示優先度"),
              _hoisted_12,
              _createVNode(_component_a_input_number, {
                placeholder: "表示優先度",
                value: _ctx.editData.sort,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editData.sort) = $event)),
                min: 0,
                style: {"widows":"100%","margin-right":"15px"},
                inputmode: "decimal",
                disabled: !_ctx.createMode && _ctx.passEdit
              }, null, 8, ["value", "disabled"]),
              _hoisted_13,
              (_ctx.passEdit)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" Password "),
                    _createVNode(_component_a_input_password, {
                      placeholder: "パスワード",
                      value: _ctx.editData.password,
                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editData.password) = $event))
                    }, null, 8, ["value"]),
                    _createTextVNode(" Password(チェック用) "),
                    _createVNode(_component_a_input_password, {
                      placeholder: "パスワード(チェック用)",
                      value: _ctx.editData.passcheck,
                      "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editData.passcheck) = $event))
                    }, null, 8, ["value"])
                  ], 64))
                : _createCommentVNode("", true),
              _hoisted_14,
              _hoisted_15,
              (!_ctx.passEdit || _ctx.createMode)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" 有効化 "),
                    _createVNode(_component_a_checkbox, {
                      checked: _ctx.editData.activate,
                      "onUpdate:checked": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.editData.activate) = $event)),
                      disabled: !_ctx.createMode && !_ctx.isAuthority
                    }, null, 8, ["checked", "disabled"]),
                    _hoisted_16,
                    _createTextVNode(" 管理者権限 "),
                    _createVNode(_component_a_checkbox, {
                      checked: _ctx.editData.authority,
                      "onUpdate:checked": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.editData.authority) = $event)),
                      disabled: !_ctx.createMode && !_ctx.isAuthority
                    }, null, 8, ["checked", "disabled"]),
                    _hoisted_17,
                    _createTextVNode(" カレンダーに表示 "),
                    _createVNode(_component_a_checkbox, {
                      checked: _ctx.editData.calendar,
                      "onUpdate:checked": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.editData.calendar) = $event)),
                      disabled: !_ctx.createMode && !_ctx.isAuthority
                    }, null, 8, ["checked", "disabled"])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            type: "primary",
            danger: "",
            shape: "round",
            style: {"float":"left","width":"100px","margin-top":"10px","margin-bottom":"10px"},
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.deleteStaff())),
            disabled: _ctx.editData.id==0,
            loading: _ctx.loading
          }, {
            default: _withCtx(() => [
              _createTextVNode("削除")
            ]),
            _: 1
          }, 8, ["disabled", "loading"]),
          _createVNode(_component_a_button, {
            type: "primary",
            shape: "round",
            style: {"float":"right","width":"100px","margin-top":"10px","margin-bottom":"10px"},
            onClick: _ctx.handleOk,
            disabled: _ctx.Disable(),
            loading: _ctx.loading
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.buttonLabel), 1)
            ]),
            _: 1
          }, 8, ["onClick", "disabled", "loading"]),
          _hoisted_18,
          _hoisted_19
        ]),
        _: 1
      }, 8, ["open", "title", "onOk"]),
      _createVNode(_component_a_modal, {
        open: _ctx.affiliationVisible,
        "onUpdate:open": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.affiliationVisible) = $event)),
        title: "会社名編集",
        footer: "''"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            placeholder: "会社名",
            value: _ctx.registAffiliation.label,
            "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.registAffiliation.label) = $event))
          }, null, 8, ["value"]),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.registAffiliationData,
            loading: _ctx.loading,
            disabled: _ctx.registAffiliation.label==null
          }, {
            default: _withCtx(() => [
              _createTextVNode("登録")
            ]),
            _: 1
          }, 8, ["onClick", "loading", "disabled"]),
          _createVNode(_component_a_button, {
            type: "primary",
            danger: "",
            onClick: _ctx.deleteAffiliation,
            loading: _ctx.loading,
            style: {"float":"right"},
            disabled: _ctx.registAffiliation.id==0
          }, {
            default: _withCtx(() => [
              _createTextVNode("削除")
            ]),
            _: 1
          }, 8, ["onClick", "loading", "disabled"])
        ]),
        _: 1
      }, 8, ["open"])
    ])
  ], 64))
}